<!--
 * @Description: 综合素质评价 详情
 * @Author: PF
 * @Date: 2024-05-20 17:32:40
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:22:01
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <ul class="mb10" style="display: flex;justify-content: space-between;">
              <li>
                <span style="font-weight: bold;">班级</span>：{{row.bjmc}}
                <span class="ml10" style="font-weight: bold;">姓名：</span>{{row.xsxm}}
                <span class="ml10" style="font-weight: bold;">学期：</span>{{row.xqmc}}
              </li>
              <li><span style="font-weight: bold;">总分</span>：{{ row.zdf }}</li>
            </ul>
          </el-header>
          <el-main>
            <el-table :data="tableData" v-loading="loading" border height="100%" :span-method="spanMethod">
            <el-table-column label="评价维度" prop="pjwd" width="150" align="center" />
            <el-table-column label="评价要素" prop="pjys" min-width="200" header-align="center" align="left" />
            <el-table-column label="评价内容" prop="pjnr" min-width="200" header-align="center" align="left" />
            <el-table-column label="评价标准" prop="pjbz" min-width="200" header-align="center" align="left" />
            <el-table-column label="得分" prop="fs" width="80" align="center" />
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import { getRowspanMethod } from '@/utils/index.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])

const loading = ref(false)

const tableData = ref([])

const spanMethod = computed(() =>
  getRowspanMethod(tableData.value, ['pjwd'])
)

const row = ref()
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loading.value = true
      actionPost({
        url: '/api/v2/xuesheng/deyupingjiapingjia/list',
        data: { dypjlbid: props.row.id }
      }).then((res) => {
        if (res.code === 200) {
          tableData.value = res.data.content || []
          row.value = res.data.head
          row.value.zdf = props.row.zdf || 0
          loading.value = false
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(tr:hover > td) {
  background-color: #fff !important;
}
</style>
